module.exports = __webpack_public_path__ + "static/img/guide-purchase-gmoney.0ce1b2e.jpg";